import { useEffect } from "react";

/* Articles listing is static HTML — redirect to the HTML file */
export default function ArticlesListPage() {
  useEffect(() => { window.location.href = "/articles/index.html"; }, []);
  return null;
}
